export type AppointmentTypeValue =
  | "SMART_METER_UPGRADE"
  | "NEW_CONNECTION"
  | "ISOLATION_SWITCH"
  | "METER_REMOVAL"
  | "METER_RELOCATION"
  | "METER_TAILS"
  | "METER_TROUBLESHOOTING"

export const APPOINTMENT_TYPE_TITLES: Record<AppointmentTypeValue, string> = {
  SMART_METER_UPGRADE: "Upgrade to smart meter",
  NEW_CONNECTION: "New connection",
  ISOLATION_SWITCH: "Isolation switch",
  METER_REMOVAL: "Meter removal",
  METER_RELOCATION: "Meter relocation",
  METER_TAILS: "Meter tails",
  METER_TROUBLESHOOTING: "Meter and IHD troubleshooting",
}
